import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QaiCallButtonComponent} from '@qai/ui';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  imports: [CommonModule, QaiCallButtonComponent, TranslocoModule],
  selector: 'app-visual-aid-call-footer',
  standalone: true,
  templateUrl: './visual-aid-call-footer.component.html',
  styleUrls: ['./visual-aid-call-footer.component.scss'],
})
export class VisualAidCallFooterComponent {
 @Input({ required: true }) isCaptionsOn = false;

  @Output() readonly settingsClicked = new EventEmitter();
  @Output() readonly captionsClicked = new EventEmitter();

  protected handleSettingsClick() {
    this.settingsClicked.emit();
  }

  protected handleCaptionsClick() {
    this.captionsClicked.emit();
  }
}
